import React, { useContext, useEffect, useState, useRef } from "react";
import { Grid, ListItem, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FixedSizeList } from "react-window";

// Contexts
import StoreContext from "../../../context/stores/StoreContext";

// Components
import Form from "./content/Form";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 460,
  },
  grid: {
    height: "100%",
  },
  list: {
    width: "100%",
    height: "100%",
    minHeight: 364,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    border: "1px solid silver",
    borderRadius: "5px",
    marginBottom: "1rem",
  },
}));

const StoreDisplay = ({ onChangePage }) => {
  const classes = useStyles();

  const {
    display_content,
    stores,
    stores_filtered,
    selected_store,
    form_data,
    form_error,
    setFormData,
    setFormError,
  } = useContext(StoreContext);

  const listRef = useRef("");
  const [store_list, setStoreList] = useState([]);

  useEffect(() => {
    // Create Store List For Display
    if (stores_filtered) setStoreList(stores_filtered);
    else setStoreList(stores);
  }, [stores, stores_filtered]);

  useEffect(() => {
    // Auto Focus List Item on Selected Store
    if (store_list.length > 0 && selected_store && selected_store.store_name) {
      const search = (store_list) =>
        store_list.store_name === selected_store.store_name;

      listRef.current.scrollToItem(store_list.findIndex(search), "smart");
    }
  }, [selected_store, store_list]);

  const handleChange = (e) => {
    if (e.target.id === "status" || e.target.id === "cod") {
      setFormData({ ...form_data, [e.target.id]: e.target.checked });
    } else {
      const id = e.target.id;
      let value = e.target.value;

      form_data[id] = value;

      switch (id) {
        case "base_url":
          if (value < 1) {
            form_error[id] = "Base URL cannot be empty!";
            form_data["store_name"] = "";
            form_data["api_key"] = "";
            form_data["api_secret"] = "";
          } else {
            if (
              value.indexOf("https://") === -1 ||
              value.indexOf(".myshopify.com") === -1
            ) {
              form_error[id] = "Base URL is invalid!";
            } else {
              form_error[id] = "";

              // Find Store Name, API Key & Secret
              const name_start = value.indexOf("@") + 1;
              const name_end = value.indexOf(".myshopify");
              form_data["store_name"] = value.substring(name_start, name_end);

              const api_start = value.indexOf("://") + 3;
              const api_end = value.indexOf("@");
              const api = value.substring(api_start, api_end);

              const index = api.indexOf(":");
              form_data["api_key"] = api.substring(0, index);
              form_data["api_secret"] = api.substring(index + 1);
            }
          }
          break;

        case "shared_secret":
          if (value < 1) {
            form_error[id] = "Shared Secret cannot be empty!";
          } else {
            form_error[id] = "";
          }
          break;

        default:
          break;
      }

      setFormData(form_data);
      setFormError(form_error);
    }
  };

  // List Item
  const renderListItem = ({ index, style, data }) => {
    const each = data[index];

    return (
      <ListItem
        key={index}
        style={style}
        button
        selected={
          selected_store && selected_store.store_name === each.store_name
        }
        onClick={() => onChangePage(each.store_name)}
      >
        <ListItemText secondary={each.store_name} />{" "}
      </ListItem>
    );
  };

  return (
    <Grid item xs={12} container direction="column">
      <Grid item container className={classes.root}>
        {" "}
        {/* Store List */}{" "}
        <Grid
          item
          xs={2}
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          className={classes.grid}
        >
          <div className={classes.list}>
            {" "}
            {store_list.length > 0 && (
              <FixedSizeList
                width="100%"
                height={450}
                itemSize={30}
                itemCount={store_list.length}
                itemData={store_list}
                ref={listRef}
              >
                {renderListItem}{" "}
              </FixedSizeList>
            )}{" "}
          </div>{" "}
        </Grid>
        {/* Form */}{" "}
        <Grid
          item
          xs={10}
          container
          justifyContent="center"
          alignItems="flex-start"
          className={classes.grid}
        >
          <Grid item xs={12} className={classes.grid}>
            {" "}
            {display_content === "" && <div />}{" "}
            {display_content === "Create" && (
              <Form formType="Create" handleChange={handleChange} />
            )}{" "}
            {display_content === "Edit" && selected_store && (
              <Form formType="Edit" handleChange={handleChange} />
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default StoreDisplay;
